const RESERVED_CONDITIONS = ['missing', 'good', 'damaged', 'scrapped']

// Reserved conditions can only have their flags edited; name is locked and they cannot be deleted
export const isReservedCondition = (record) => !!record && (record.isReserved ||
  RESERVED_CONDITIONS.includes(String(record.name || '').trim().toLowerCase()))
